module.exports = __webpack_public_path__ + "131d4438569ef584d784a6228eedb221-AppleLogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/states/assets/AppleLogo.png
// module id = 742
// module chunks = 0